import { ThemeProvider } from 'styled-components';
import GlobalStyles from './assets/styles/global';
import AllRoutes from './routes/AllRoutes';
import ClientRoutes from './routes/ClientRoutes';
import LoginRoute from './routes/LoginRoute';

import { useAppContext } from './contexts/auth';

import {
  Container, PageContainer, RouteContainer, ThemeRadioButtonsContainer,
} from './components/App/styles';
import ThemeRadioButton from './components/ThemeRadioButton';

import darkTheme from './assets/styles/themes/dark';
import defaultTheme from './assets/styles/themes/default';

import moon from './assets/images/icons/moon.svg';
import sun from './assets/images/icons/sun.svg';

import { useLocation } from 'react-router-dom';
import Loader from './components/Loader';
import useGetGeneralAppData from './hooks/useGetGeneralAppData';
import useLocalState from './hooks/useLocalState';

export default function Routes() {
  const [theme, setTheme] = useLocalState('theme', defaultTheme);
  const { signed, isLoading } = useAppContext();
  const { userProfile } = useGetGeneralAppData();
  const location = useLocation();
  const currentRoute = location.pathname;

  const routesWithAppHeaderVisible = [
    '/',
    '/clientUsers',
    '/company',
    '/company/settings',
    '/company/branches',
    '/company/financial',
    '/company/financial/new/:serviceType',
    '/company/financial/edit/:codCondCom',
    '/company/financial/installments/:codCondCom',
    '/workplaces',
    '/workplaces/new',
    '/departments',
    '/lines',
    '/vehicles',
    '/passengers',
    '/consults/dashboard',
    '/consults/new',
    '/consults/search',
    '/consults/files',
    '/dashboard',
    '/triangulation',
    '/autImplantation',
    '/consults/file',
    '/linesOperatorsExceptions',
    '/importVtRegistrationData',
  ];

  const isAppHeaderVisible = routesWithAppHeaderVisible.some((x) => (x === currentRoute) || x.includes('linesOperatorsExceptions'));

  if (isLoading) return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <Loader isLoading={isLoading} />
    </ThemeProvider>
  );

  return signed
    ? (
      <ThemeProvider theme={theme}>
        <GlobalStyles />
        <Loader isLoading={isLoading} />
        <Container>
          <PageContainer>
            <RouteContainer isAppHeaderVisible={isAppHeaderVisible}>
              <div className="darkMode">
                <ThemeRadioButtonsContainer>
                  <ThemeRadioButton
                    onClick={() => setTheme(defaultTheme)}
                    selected={theme.colors.background != '#121212'}
                  >
                    <img src={sun} alt="lightTheme" />
                  </ThemeRadioButton>

                  <ThemeRadioButton
                    onClick={() => setTheme(darkTheme)}
                    selected={theme.colors.background == '#121212'}
                  >
                    <img src={moon} alt="darkTheme" />
                  </ThemeRadioButton>
                </ThemeRadioButtonsContainer>
              </div>

              {userProfile >= 10
                ? (
                  <ClientRoutes />
                )
                : (
                  <AllRoutes />
                )}

            </RouteContainer>
          </PageContainer>
        </Container>
      </ThemeProvider>
    )
    : (
      <ThemeProvider theme={theme}>
        <GlobalStyles />
        <Loader isLoading={isLoading} />
        <PageContainer>
          <div className="darkModeAtLoginPage">
            <ThemeRadioButtonsContainer>
              <ThemeRadioButton
                onClick={() => setTheme(defaultTheme)}
                selected={theme.colors.background != '#121212'}
              >
                <img src={sun} alt="lightTheme" />
              </ThemeRadioButton>

              <ThemeRadioButton
                onClick={() => setTheme(darkTheme)}
                selected={theme.colors.background == '#121212'}
              >
                <img src={moon} alt="darkTheme" />
              </ThemeRadioButton>
            </ThemeRadioButtonsContainer>
          </div>
        </PageContainer>
        <LoginRoute />
      </ThemeProvider>
    );
}
